
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { StudentService } from 'src/app/_services/student.service';
import { QuizEnvelop } from './../../_models/quizEnvelop';
import { Subscription } from './../../_models/subscription';
import { AuthService } from './../../_services/auth.service';
import { QuizService } from './../../_services/quiz.service';



@Component({
  selector: 'app-show-quiz',
  templateUrl: './show-quiz.component.html',
  styleUrls: ['./show-quiz.component.css']
})
export class ShowQuizComponent implements OnInit {
  public quizEnvelop:QuizEnvelop = undefined
  learner:any={}
  subscription = new Subscription()
  subscriptionId=0
  isPremium:false
  studentUserId:0
  imageSource:any
  downloading=false
  loading=true
  renderMathNow=false
  server_quiz_envelop_id:number=undefined
  imageQuestionListCount =[]
  imageFoundCount=0
  imageQuestionsCount =0
  lastQuestionRendered=false
  title="Math Quiz for Practice"
  renderCounter=0
  questionCount=0
  constructor(
    public authService:AuthService,
    private route: ActivatedRoute,
    private studentService:StudentService,
    private quizService:QuizService,
    private titleService:Title,
    private metaService:Meta
  ){
this.titleService.setTitle(this.title)
this.metaService.updateTag(
  {name:"description",content:"Show list of math quiz for practice and fun"}
)
  }

  ngOnInit(): void {
    this.studentService.minStudentData.subscribe(
      data =>{
       this.learner=data
    })

    this.route.params.subscribe(
      myParams=>{
        this.server_quiz_envelop_id = +myParams['server_quiz_envelop_id']

        if(this.server_quiz_envelop_id){
          this.quizService.getQuizEnvelop(this.server_quiz_envelop_id).subscribe(
            quizEnvelopData=>{
              this.quizEnvelop=quizEnvelopData
              this.questionCount =this.quizEnvelop.questions.length
              //this.countImages()
              this.loading=false

             }
          )
        }
      }
    )
    }
renderMathPage(value:boolean){
  this.renderCounter+=1

  if(this.renderCounter==this.questionCount){
    this.renderMathNow=value
  }

}
imageFoundEvent(n:number){

    this.imageFoundCount+=n
    if((this.imageFoundCount==this.imageQuestionsCount) && this.lastQuestionRendered){
      this.renderMathPage(true)
    }
}
renderLastQuestion(value:boolean){
  this.lastQuestionRendered=value
  if((this.imageFoundCount==this.imageQuestionsCount) && this.lastQuestionRendered){
    this.renderMathPage(true)
  }
}
downloadPdf(quizEnvelopId:number){
  this.downloading=true
  this.studentService.getWorksheet(quizEnvelopId).subscribe({
    next:(data:ResultData)=>{
      this.imageSource= `data:application/pdf;base64,${data.rs.data}`
      this.downloadMyPdf(quizEnvelopId)
  }
    })

}

downloadMyPdf(quizEnvelopId:number) {

   const link = document.createElement("a");
   let fileName= this.quizEnvelop.studentName+"_quiz_"+quizEnvelopId+"_"+Date.now()
   link.href = this.imageSource;
   link.download = `${fileName}.pdf`
   this.downloading=false
   link.click();

 }

countImages(){
  for(let k = 0; k < this.quizEnvelop.questions.length;k++){
    let question = this.quizEnvelop.questions[k]
    if(question.imageListQuestionBody.length>0){
      this.imageQuestionsCount+=1

    }

  }
}

}
